@if (isOpen()) {
<div class="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] backdrop-blur-sm animate-fade-in-fast" (click)="onBackdropClick($event)">
    <div class="bg-white w-full max-w-2xl h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden relative m-4">
        
        <!-- Header -->
        <div class="p-5 border-b border-gray-200 bg-slate-50 flex justify-between items-center flex-shrink-0">
            <div>
                <h2 class="text-xl font-bold text-slate-800 flex items-center gap-2">
                    <i class="fa-solid fa-scale-balanced text-emerald-600"></i>
                    ข้อกำหนดและนโยบายความเป็นส่วนตัว
                </h2>
                <p class="text-xs text-slate-500 mt-1">Terms of Service & Privacy Policy (Medical Cannabis)</p>
            </div>
            <button (click)="onClose()" class="text-slate-400 hover:text-slate-600 transition-colors">
                <i class="fa-solid fa-times text-2xl"></i>
            </button>
        </div>

        <!-- Tabs -->
        <div class="flex border-b border-gray-200 bg-white flex-shrink-0">
            <button (click)="activeTab.set('tos')" 
                    [class]="'flex-1 py-3 text-sm font-bold text-center border-b-2 transition-colors ' + (activeTab() === 'tos' ? 'border-emerald-500 text-emerald-700 bg-emerald-50' : 'border-transparent text-slate-500 hover:bg-slate-50')">
                ข้อตกลงการใช้งาน (ToS)
            </button>
            <button (click)="activeTab.set('pdpa')" 
                    [class]="'flex-1 py-3 text-sm font-bold text-center border-b-2 transition-colors ' + (activeTab() === 'pdpa' ? 'border-blue-500 text-blue-700 bg-blue-50' : 'border-transparent text-slate-500 hover:bg-slate-50')">
                นโยบายความเป็นส่วนตัว (PDPA)
            </button>
        </div>

        <!-- Content (Scrollable) -->
        <div class="flex-grow overflow-y-auto p-6 text-sm text-slate-700 leading-relaxed custom-scrollbar">
            
            @if (activeTab() === 'tos') {
                <div class="space-y-4">
                    <h3 class="font-bold text-lg text-slate-900 border-b pb-2 mb-2">ข้อตกลงและเงื่อนไขการให้บริการ (Terms of Service)</h3>
                    
                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">1. บทนำและสถานะของผู้ให้บริการ</h4>
                        <p>แพลตฟอร์มนี้ ("CHUAMKAN") ทำหน้าที่เป็นเพียง <strong>"ตัวกลางทางเทคโนโลยี" (Technology Intermediary)</strong> ในการเชื่อมต่อระหว่างผู้ป่วยกับสถานพยาบาล (คลินิก) หรือร้านยาที่ได้รับอนุญาตเท่านั้น ทางแพลตฟอร์มมิได้เป็นผู้ให้บริการทางการแพทย์โดยตรง การตัดสินใจในการรักษาและการจ่ายยาขึ้นอยู่กับดุลยพินิจของแพทย์หรือเภสัชกรผู้ได้รับใบอนุญาตแต่เพียงผู้เดียว</p>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">2. คุณสมบัติผู้ใช้งาน (Age Restriction)</h4>
                        <p class="text-red-600 font-bold bg-red-50 p-2 rounded border border-red-200">
                            <i class="fa-solid fa-ban mr-1"></i> บริการนี้สงวนสิทธิ์สำหรับผู้ที่มีอายุ 20 ปีบริบูรณ์ขึ้นไปเท่านั้น
                        </p>
                        <p>ข้าพเจ้ายืนยันว่าข้าพเจ้ามีอายุครบ 20 ปีบริบูรณ์ ไม่เป็นสตรีมีครรภ์ หรือสตรีให้นมบุตร ตามข้อกำหนดของกฎหมายที่เกี่ยวข้องกับการใช้กัญชาทางการแพทย์</p>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">3. ข้อจำกัดความรับผิด (Limitation of Liability)</h4>
                        <p>แพลตฟอร์มจะไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการใช้ผลิตภัณฑ์กัญชา หรือผลข้างเคียงจากการรักษา ข้อมูลสุขภาพที่ท่านให้ไว้ถือเป็นความจริงทุกประการ หากมีการปกปิดข้อมูลสุขภาพ ทางคลินิกและแพลตฟอร์มขอสงวนสิทธิ์ในการปฏิเสธความรับผิดชอบทุกกรณี</p>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">4. การใช้งานที่ผิดกฎหมาย</h4>
                        <p>ห้ามมิให้ผู้ใช้งานนำใบรับรองแพทย์หรือผลิตภัณฑ์ที่ได้รับไปใช้ในทางที่ผิดกฎหมาย จำหน่ายต่อ หรือนำไปใช้เพื่อสันทนาการในที่สาธารณะ ใบรับรองแพทย์ที่ออกให้มีไว้เพื่อการครอบครองและใช้เพื่อการรักษาโรคเฉพาะตัวบุคคลเท่านั้น</p>
                    </div>
                </div>
            } @else {
                <div class="space-y-4">
                    <h3 class="font-bold text-lg text-slate-900 border-b pb-2 mb-2">นโยบายคุ้มครองข้อมูลส่วนบุคคล (Privacy Policy)</h3>
                    
                    <div class="bg-blue-50 p-3 rounded-lg border border-blue-200 text-blue-800 text-xs mb-4">
                        <i class="fa-solid fa-shield-halved mr-1"></i> เอกสารนี้จัดทำขึ้นเพื่อให้สอดคล้องกับ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">1. ข้อมูลที่จัดเก็บ (Data Collected)</h4>
                        <ul class="list-disc list-inside pl-2 space-y-1 text-slate-600">
                            <li>ข้อมูลระบุตัวตน: ชื่อ-นามสกุล, เลขบัตรประชาชน, วันเดือนปีเกิด</li>
                            <li>ข้อมูลการติดต่อ: เบอร์โทรศัพท์, ที่อยู่</li>
                            <li>ข้อมูลสุขภาพ: ประวัติการแพ้ยา, โรคประจำตัว, อาการเจ็บป่วย, สัญญาณชีพ</li>
                            <li>ข้อมูลชีวภาพ: ภาพถ่ายใบหน้า, ภาพถ่ายบัตรประชาชน</li>
                        </ul>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">2. วัตถุประสงค์การใช้ข้อมูล</h4>
                        <p>เพื่อใช้ในการวินิจฉัยโรคโดยแพทย์, ออกใบรับรองแพทย์, และจัดทำรายงานส่งสำนักงานคณะกรรมการอาหารและยา (อย.) ตามรูปแบบ ภท.27 และ ภท.28 ตามที่กฎหมายกำหนด</p>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">3. การโอนย้ายข้อมูลระหว่างประเทศ (Cross-border Data Transfer)</h4>
                        <div class="bg-amber-50 p-3 rounded border border-amber-200">
                            <p class="font-bold text-amber-900 mb-1"><i class="fa-solid fa-server mr-1"></i> สถานที่จัดเก็บข้อมูล</p>
                            <p>เพื่อประสิทธิภาพและความปลอดภัยสูงสุดของระบบ ข้อมูลของท่านจะถูกจัดเก็บและประมวลผลบนระบบคลาวด์ที่มีมาตรฐานความปลอดภัยระดับโลก ดังนี้:</p>
                            <ul class="list-disc list-inside mt-2 pl-2">
                                <li><strong>Render:</strong> ผู้ให้บริการ Application Server (ตั้งอยู่ที่สหรัฐอเมริกา/สิงคโปร์)</li>
                                <li><strong>Supabase:</strong> ผู้ให้บริการฐานข้อมูล (Database) ที่มีการเข้ารหัสข้อมูล (ตั้งอยู่ที่สิงคโปร์)</li>
                            </ul>
                        </div>
                        <p class="mt-2 text-xs text-slate-500">ทางแพลตฟอร์มได้เลือกผู้ให้บริการที่มีมาตรการรักษาความปลอดภัยของข้อมูลที่ได้มาตรฐานสากล (ISO/IEC 27001) เพื่อปกป้องข้อมูลของท่าน</p>
                    </div>

                    <div class="section">
                        <h4 class="font-bold text-slate-800 mb-1">4. ระยะเวลาการจัดเก็บ</h4>
                        <p>ข้อมูลเวชระเบียนจะถูกจัดเก็บเป็นระยะเวลาอย่างน้อย 5-10 ปี ตามมาตรฐานการประกอบวิชาชีพเวชกรรมและกฎหมายที่เกี่ยวข้อง</p>
                    </div>
                </div>
            }
        </div>

        <!-- Footer -->
        <div class="p-4 border-t border-gray-200 bg-slate-50 flex justify-end gap-3 flex-shrink-0">
            <button (click)="onClose()" class="px-6 py-2.5 bg-slate-200 text-slate-700 font-bold rounded-lg hover:bg-slate-300 transition-colors">
                ปิดหน้าต่าง (Close)
            </button>
            <button (click)="acceptAndClose()" class="px-6 py-2.5 bg-emerald-600 text-white font-bold rounded-lg hover:bg-emerald-700 transition-colors shadow-lg flex items-center gap-2">
                <i class="fa-solid fa-check"></i> รับทราบ (Acknowledge)
            </button>
        </div>
    </div>
</div>
}
<style>
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #94a3b8;
  border-radius: 10px;
  border: 2px solid #f1f5f9;
}
.section {
    @apply mb-4 pb-4 border-b border-dashed border-slate-200 last:border-b-0;
}
</style>